import React from "react";
import { WaziWordmark } from "./Logo";

const Footer = () => (
  <footer className="border-t border-[#E2E8F0] bg-[#F7FAFC] mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
      <div className="col-span-2">
        <WaziWordmark size={34} />
        <p className="mt-4 text-[#718096] text-sm max-w-md font-sans">
          Wazi helps South African entrepreneurs win more work through WhatsApp. Professional quotes, trusted reviews, simple business — built for hustle.
        </p>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-[#2D3748] mb-3">For painters</h4>
        <ul className="space-y-2 text-sm text-[#718096]">
          <li><a href="/get-started" className="hover:text-[#25D366]">Sign up free</a></li>
          <li><a href="#how" className="hover:text-[#25D366]">How it works</a></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-[#2D3748] mb-3">For customers</h4>
        <ul className="space-y-2 text-sm text-[#718096]">
          <li><a href="/find-painter" className="hover:text-[#25D366]">Find a painter</a></li>
          <li><a href="mailto:hello@wazi.chat" className="hover:text-[#25D366]">hello@wazi.chat</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#718096]">
        <span>© {new Date().getFullYear()} Wazi. Built in South Africa. 🇿🇦</span>
        <div className="flex items-center gap-4">
          <span className="hidden sm:inline">Professional · Trustworthy · Simple · Mobile-first</span>
          <a href="/admin/login" data-testid="footer-admin-link" className="text-[#718096] hover:text-[#2D3748] underline-offset-2 hover:underline">Admin</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
